import * as v1 from "./v1/Colors";
import * as v2 from "./v2/Colors";

const SystemColors = {
  v1,
  v2,
};

export default SystemColors;